import { render, staticRenderFns } from "./key-contact-loader.vue?vue&type=template&id=2aaae2f8"
import script from "./key-contact-loader.vue?vue&type=script&lang=js"
export * from "./key-contact-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aaae2f8')) {
      api.createRecord('2aaae2f8', component.options)
    } else {
      api.reload('2aaae2f8', component.options)
    }
    module.hot.accept("./key-contact-loader.vue?vue&type=template&id=2aaae2f8", function () {
      api.rerender('2aaae2f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/contact/components/key-contact-loader.vue"
export default component.exports